import builder from '../builder';
import NavigationMenuVertical from '../../streamline-icons/bold/navigation-menu-vertical.svg';

export default builder(
  'IconNavigationMenuVerticalBold',
  NavigationMenuVertical,
);
